import {FC} from 'react'
import {Trash01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import type {AgendaEventAppointment} from '@/features/agenda/types'
import {DeleteAgendaEventConfirmationDialog} from '@/features/agenda/components/delete-agenda-event-confirmation-dialog/DeleteAgendaEventConfirmationDialog'
import {StyledDeleteAgendaEventButton} from './style'
import {AgendaEventTreatmentSchema} from '@/features/agenda/formSchemas'

interface DeleteAgendaEventButtonProps {
    event: AgendaEventAppointment
    isDisabled?: boolean
    repetitionData?: AgendaEventTreatmentSchema['repetitionData']
}

export const DeleteAgendaEventButton: FC<DeleteAgendaEventButtonProps> = ({event, isDisabled, repetitionData}) => {
    const {t} = useTranslation()
    const deleteDialog = useDialogStore()
    const detailsDialog = useDialogContext()

    return (
        <>
            <StyledDeleteAgendaEventButton
                variant="ghostDanger"
                onClick={() => deleteDialog.show()}
                disabled={isDisabled}
                shape="rectangle"
                fullWidth
            >
                <Trash01Icon />
                {t('commons:delete')}
            </StyledDeleteAgendaEventButton>
            <DeleteAgendaEventConfirmationDialog
                event={event}
                dialogStore={deleteDialog}
                repetitionData={repetitionData}
                onDeletionSuccess={() => detailsDialog?.hide()}
            />
        </>
    )
}
